var cov_ht9nll5vp = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Upload/RemoveConfirm.tsx",
      hash = "376d786fabba275f87273e77467e07b6d124870e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Upload/RemoveConfirm.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 11,
          column: 16
        }
      },
      "1": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 14,
          column: 5
        }
      },
      "2": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 66
        }
      },
      "3": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 16,
          column: 62
        }
      },
      "4": {
        start: {
          line: 20,
          column: 32
        },
        end: {
          line: 20,
          column: 42
        }
      },
      "5": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 49
        }
      },
      "6": {
        start: {
          line: 21,
          column: 25
        },
        end: {
          line: 21,
          column: 49
        }
      },
      "7": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 30
        }
      },
      "8": {
        start: {
          line: 26,
          column: 25
        },
        end: {
          line: 26,
          column: 35
        }
      },
      "9": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 30,
          column: 6
        }
      },
      "10": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 30
        }
      },
      "11": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 28,
          column: 30
        }
      },
      "12": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 24
        }
      },
      "13": {
        start: {
          line: 34,
          column: 24
        },
        end: {
          line: 34,
          column: 34
        }
      },
      "14": {
        start: {
          line: 35,
          column: 24
        },
        end: {
          line: 35,
          column: 34
        }
      },
      "15": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 29
        }
      },
      "16": {
        start: {
          line: 36,
          column: 18
        },
        end: {
          line: 36,
          column: 29
        }
      },
      "17": {
        start: {
          line: 37,
          column: 25
        },
        end: {
          line: 37,
          column: 86
        }
      },
      "18": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 45,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 47
          },
          end: {
            line: 17,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 40
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 22
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 27,
            column: 23
          },
          end: {
            line: 27,
            column: 24
          }
        },
        loc: {
          start: {
            line: 27,
            column: 34
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 27
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 3
          }
        },
        loc: {
          start: {
            line: 33,
            column: 11
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 33
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 49
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 21,
            column: 49
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 30
          }
        }, {
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 28,
            column: 30
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 29
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 36,
            column: 29
          }
        }],
        line: 36
      },
      "3": {
        loc: {
          start: {
            line: 37,
            column: 25
          },
          end: {
            line: 37,
            column: 86
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 37,
            column: 55
          },
          end: {
            line: 37,
            column: 62
          }
        }, {
          start: {
            line: 37,
            column: 65
          },
          end: {
            line: 37,
            column: 86
          }
        }],
        line: 37
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Upload/RemoveConfirm.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { Component } from '../component';
import Popover from '../Popover';

var RemoveConfirm =
/*#__PURE__*/
function (_Component) {
  _inherits(RemoveConfirm, _Component);

  var _super = _createSuper2(RemoveConfirm);

  function RemoveConfirm(props) {
    var _this;

    _classCallCheck(this, RemoveConfirm);

    cov_ht9nll5vp.f[0]++;
    cov_ht9nll5vp.s[0]++;
    _this = _super.call(this, props);
    cov_ht9nll5vp.s[1]++;
    _this.state = {
      visible: false
    };
    cov_ht9nll5vp.s[2]++;
    _this.handleRemoveConfirm = _this.handleRemoveConfirm.bind(_assertThisInitialized(_this));
    cov_ht9nll5vp.s[3]++;
    _this.handleRemoveLater = _this.handleRemoveLater.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RemoveConfirm, [{
    key: "handleRemoveConfirm",
    value: function handleRemoveConfirm(visible) {
      cov_ht9nll5vp.f[1]++;

      var _ref = (cov_ht9nll5vp.s[4]++, this.props),
          onVisibleChange = _ref.onVisibleChange;

      cov_ht9nll5vp.s[5]++;

      if (onVisibleChange) {
        cov_ht9nll5vp.b[0][0]++;
        cov_ht9nll5vp.s[6]++;
        onVisibleChange(visible);
      } else {
        cov_ht9nll5vp.b[0][1]++;
      }

      cov_ht9nll5vp.s[7]++;
      this.setState({
        visible: visible
      });
    }
  }, {
    key: "handleRemoveLater",
    value: function handleRemoveLater() {
      cov_ht9nll5vp.f[2]++;

      var _ref2 = (cov_ht9nll5vp.s[8]++, this.props),
          onRemove = _ref2.onRemove;

      cov_ht9nll5vp.s[9]++;
      return new Promise(function (resolve) {
        cov_ht9nll5vp.f[3]++;
        cov_ht9nll5vp.s[10]++;

        if (onRemove) {
          cov_ht9nll5vp.b[1][0]++;
          cov_ht9nll5vp.s[11]++;
          onRemove();
        } else {
          cov_ht9nll5vp.b[1][1]++;
        }

        cov_ht9nll5vp.s[12]++;
        resolve(undefined);
      });
    }
  }, {
    key: "render",
    value: function render() {
      cov_ht9nll5vp.f[4]++;

      var _ref3 = (cov_ht9nll5vp.s[13]++, this.state),
          visible = _ref3.visible;

      var _ref4 = (cov_ht9nll5vp.s[14]++, this.props),
          confirm = _ref4.confirm;

      cov_ht9nll5vp.s[15]++;

      if (!confirm) {
        cov_ht9nll5vp.b[2][0]++;
        cov_ht9nll5vp.s[16]++;
        return null;
      } else {
        cov_ht9nll5vp.b[2][1]++;
      }

      var confirmProps = (cov_ht9nll5vp.s[17]++, typeof confirm === 'object' ? (cov_ht9nll5vp.b[3][0]++, confirm) : (cov_ht9nll5vp.b[3][1]++, {
        children: confirm
      }));
      cov_ht9nll5vp.s[18]++;
      return (
        /*#__PURE__*/
        React.createElement(Popover.Confirm, Object.assign({}, confirmProps, {
          onOk: this.handleRemoveLater,
          visible: visible,
          onVisibleChange: this.handleRemoveConfirm,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 39,
            columnNumber: 7
          }
        }))
      );
    }
  }]);

  return RemoveConfirm;
}(Component);

export { RemoveConfirm as default };